export default __webpack_public_path__ + "static/media/Topicks-android.d6da5769.png";